import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { requestPassword } from '../core/_requests'

const initialValues = {
  correo: '',
}

const forgotPasswordSchema = Yup.object().shape({
  correo: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Correo es requerido'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.correo)
          .then(({ data: { result } }) => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 2000)
    },
  })

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>¿Olvidaste Contraseña?</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>
          Ingresa correo para reestablecer contraseña.
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger text-center'>
          <div className='alert-text font-weight-bold'>
            Lo siento, detectamos un error, intente de nuevo.
          </div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 alert alert-info text-center'>
          <div className='text-info'>Solicitud enviada, revise su correo</div>
        </div>
      )}
      {/* end::Title */}

      {loading && (
        <div className='mb-10 alert alert-info text-center'>
          <span className='indicator-progress' style={{ display: 'block' }}>
            Enviando...
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        {/* <label className='form-label fw-bolder text-gray-900 fs-6'>Correo</label> */}
        <input
          type='email'
          placeholder='Correo'
          autoComplete='off'
          {...formik.getFieldProps('correo')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.correo && formik.errors.correo },
            {
              'is-valid': formik.touched.correo && !formik.errors.correo,
            }
          )}
        />
        {formik.touched.correo && formik.errors.correo && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.correo}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' id='kt_password_reset_submit' className='btn btn-primary w-150px me-4'>
          {!loading && <span className='indicator-label'>Enviar</span>}
          {/* <span className='indicator-label'>Enviar</span> */}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Enviando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Cancelar
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
  )
}
